import {
	subscribeOnStream,
	unsubscribeFromStream,
	getHistoryPromise
} from './streaming'

const supportedResolutions = ['1', '5', '15', '30', '60', '240', '1D', '1W', '1M']
const config = {
	supported_resolutions: supportedResolutions,
	supports_group_request: true,
	supports_marks: false,
	supports_search: false,
	supports_timescale_marks: false
}
const lastBarsCache = new Map();
let currentResolution = 1
const setResolution = (resolution) => {
	currentResolution = resolution
}
export const getResolution = () => currentResolution

const getAsset = () => JSON.parse(localStorage.getItem('trading-selected-asset'))

export default {
	calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
		setResolution(resolution)
		// console.log('=====calculateHistoryDepth running')
	},
	getBars: async function (symbolInfo, resolution, from, to, onHistoryCallback, onErrorCallback, firstDataRequest) {
		try {
			if (from > 0 && (from + '').length > 10) {
				throw new Error([ 'Got a JS time instead of Unix one.', from, to ])
			}
			// eslint-disable-next-line
			// console.log('=====getBars running')
			const historyFeeds = await getHistoryPromise(symbolInfo.name, from, to, resolution, getAsset())
			const data = historyFeeds.data
			const noData = data.s === 'no_data'
			if (data.s !== 'ok' && !noData) {
				if (!onErrorCallback) {
					onErrorCallback(data.s)
				}
				return
			}
			let bars = []
			let barsCount = noData ? 0 : data.t.length
			let volumePresent = typeof data.v != 'undefined'
			let ohlPresent = typeof data.o != 'undefined'
			for (let i = 0; i < barsCount; ++i) {
				let barValue = {
					close: +data.c[i],
					time: data.t[i] * 1000
				}
				if (ohlPresent) {
					barValue.open = +data.o[i]
					barValue.high = +data.h[i]
					barValue.low = +data.l[i]
				} else {
					barValue.open = barValue.high = barValue.low = +barValue.close
				}

				if (volumePresent) {
					barValue.volume = +data.v[i]
				}
				bars.push(barValue)
			}
			if (bars.length > 0) {
				bars.sort(function(a, b) {
					if (a.time < b.time)
						return -1
					if (a.time > b.time)
						return 1
					return 0
				})
			}
			if (firstDataRequest) {
				lastBarsCache.set(symbolInfo.full_name, {
					...bars[bars.length - 1]
				});
			}
			// eslint-disable-next-line
			// console.log(`[getBars]: returned ${bars.length} bar(s)`);
			onHistoryCallback(bars, { nextTime: data.nb || data.nextTime, noData: noData })
		} catch (e) {
			// eslint-disable-next-line
			// console.log('[getBars]: Get error', e)
			onErrorCallback(e)
		}
	},
	getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		// eslint-disable-next-line
		// console.log('=====getMarks running')
	},
	getServerTime: cb => {
		// eslint-disable-next-line
		// console.log('=====getServerTime running')
	},
	getTimeScaleMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
		// eslint-disable-next-line
		// console.log('=====getTimeScaleMarks running')
	},
	onReady: cb => {
		// eslint-disable-next-line
		// console.log('=====onReady running')
		setTimeout(() => cb(config), 0)
	},

	resolveSymbol: (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
		// eslint-disable-next-line
		// console.log('======resolveSymbol running', symbolName)
		let symbolInfo = {
			data_status: 'streaming',
			description: '',
			has_empty_bars: false,
			has_intraday: true,
			has_seconds: true,
			intraday_multipliers: ['1s', '1'],
			minmov: 1,
			name: symbolName,
			pricescale: 100000,
			seconds_multipliers: ['1'],
			session: '24x7',
			supported_resolutions:  supportedResolutions,
			ticker: symbolName,
			timeZone: 'America/New_York',
			type: 'stock',
			volume_precision: 5
		}
		// eslint-disable-next-line
		// console.log('Resolving that symbol....', symbolInfo)
		setTimeout(() => onSymbolResolvedCallback(symbolInfo), 0)
	},
	subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
		// eslint-disable-next-line
		console.log('=====subscribeBars running', resolution)
		const range = 1
		subscribeOnStream(symbolInfo,
			resolution,
			onRealtimeCallback,
			subscriberUID,
			onResetCacheNeededCallback,
			lastBarsCache.get(symbolInfo.full_name),
			getAsset(),
			range)
	},
	unsubscribeBars: subscriberUID => {
		unsubscribeFromStream(subscriberUID)
		// eslint-disable-next-line
		// console.log('=====unsubscribeBars running')
	}
}
